import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DataTable from '../DataTable'
import ClientStore from './ClientStore'
import Tooltip from '../../UniformComponents/Tooltip'
import Badge from '../../UniformComponents/Badge'
import Button from '../../UniformComponents/Button'
import Anchor from '../../UniformComponents/Anchor'
import Checkbox from '../form/Checkbox'
import SearchLayout from '../Layouts/Search'
import ClientEdit from './ClientEdit'
import { removeQueryParam, setQueryParam, getQueryParam } from '../../utils/helpers'

const CLIENT_PARAM = 'clientId'

@observer
class ClientSearch extends Component {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.state = {
            showModal: false,
            clientId: 0,
        }
        this.clientStore = new ClientStore(store)

        this.setColumns()
    }

    async componentDidMount() {
        const { store, location } = this.props
        const { clientStore } = this

        store.breadcrumps = [
            {
                name: 'client',
                url: '/client',
                title: 'Manage Clients',
            },
        ]

        await clientStore.initSearch()

        this.checkQueryParam(location)
    }

    checkQueryParam = (location) => {
        const clientId = getQueryParam(location, CLIENT_PARAM)
        if (clientId === -1) return
        if (clientId !== 0) {
            this.setState({ clientId })
        }
        this.toggleModal()
    }

    toggleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }))
    }

    handleOpenModal = (clientId) => {
        const { location, history } = this.props

        setQueryParam(location, history, CLIENT_PARAM, clientId)
        this.setState({ clientId })
        this.toggleModal()
    }

    handleCloseModal = () => {
        const { location, history } = this.props

        removeQueryParam(location, history, CLIENT_PARAM)
        this.setState({ clientId: 0 })
        this.toggleModal()
        this.clientStore.resetFormState()
    }

    setColumns = () => {
        this.columns = [
            {
                name: 'Status',
                key: 'active',
                cellClass: 'status',
                dataTransform: (active) => {
                    switch (active) {
                        case true: return (
                            <Badge
                                type="success"
                                cssClass="status-badge"
                                label={i18n.t('table.col.status.active', 'Active')}
                                icon="fa-regular fa-circle-check"
                            />
                        )
                        case false: return (
                            <Badge
                                type="error"
                                cssClass="status-badge"
                                label={i18n.t('table.col.status.inactive', 'Inactive')}
                                icon="fa-regular fa-ban"
                            />
                        )
                        default: return null
                    }
                },
            },
            {
                name: 'Client name',
                key: 'name',
                cellClass: 'bold',
            },
            {
                name: 'Postcode',
                key: 'postcode',
            },
            {
                name: 'Country',
                key: 'country',
            },
            {
                name: '',
                key: 'clientId',
                cellClass: 'overflow',
                dataTransform: (clientId) => (
                    this.clientStore.clientEditAccess(clientId, this.props.role) ? (
                        <div className="survey-btn-wrapper">
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={() => {
                                    this.handleOpenModal(clientId)
                                }}
                            >
                                <Tooltip
                                    text={i18n.t('clientSearch.editClient', 'Edit Client')}
                                    direction="left"
                                />
                                <i className="fa-light fa-edit" />
                            </Anchor>
                        </div>
                    ) : null
                ),
            },
        ]
    }

    renderFilterOptions = () => {
        const { clientStore } = this
        return (
            <Fragment>
                <fieldset className="filter">
                    <p className="legend-title">
                        Client status
                    </p>
                    {Object.keys(clientStore.status).map((key) => (
                        <Checkbox
                            name={clientStore.status[key].name}
                            onBlur={() => clientStore.toggleStatus(clientStore.status[key].name)}
                            checked={clientStore.status[key].value}
                            label={clientStore.status[key].label}
                        />
                    ))}
                </fieldset>
            </Fragment>
        )
    }

    renderButtons = () => {
        const { clientStore, props: { role }, state: { clientId } } = this

        if (clientStore.clientEditAccess(clientId, role)) {
            return (
                <Button
                    cssClass="add-button primary regular"
                    onClick={() => { this.handleOpenModal(0) }}
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('clientSearch.addClient', 'Create new client')}
                />
            )
        }
        return null
    }

    renderTablePanel = () => {
        const { clientStore } = this
        return (
            <DataTable
                store={clientStore}
                inMemory
                dataSet={clientStore.filteredList || []}
                columns={this.columns}
                cssClass="search-table"
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('client.introText'),
        }}
        />
    )

    render() {
        const {
            store, history, match, location, role,
        } = this.props
        const { showModal, clientId } = this.state
        const { clientStore } = this
        return (
            <Fragment>
                <SearchLayout
                    pageTitle="Clients"
                    renderFilterOptions={this.renderFilterOptions}
                    renderButtons={this.renderButtons}
                    renderTablePanel={this.renderTablePanel}
                    renderGuide={this.renderGuide}
                    searchStore={clientStore}
                />
                <ClientEdit
                    showModal={showModal}
                    handleCloseModal={this.handleCloseModal}
                    store={store}
                    clientStore={clientStore}
                    history={history}
                    match={match}
                    location={location}
                    clientId={clientId}
                    role={role}
                />
            </Fragment>
        )
    }
}

export default ClientSearch
